export const subtitles = {
    "1": {
        "startTime": 8.427,
        "endTime": 13.239,
        "transcript": "Atren kitak', atren qavcinek-llu allrakungqellren.",
        "translation": "Now, your name, and how old you are."
    },
    "2": {
        "startTime": 13.476,
        "endTime": 17.188,
        "transcript": "Atqa-qaa? Kass'atun-qaa atqa?",
        "translation": "My name? My English name?"
    },
    "3": {
        "startTime": 17.192,
        "endTime": 18.836,
        "transcript": "Kass'atun Yugtun-llu.",
        "translation": "In English and Yup'ik."
    },
    "4": {
        "startTime": 20.2,
        "endTime": 25.889,
        "transcript": "Yugtun-llu pilaraatnga Angukarnamek.",
        "translation": "In Yup'ik, they call me Angukarnaq."
    },
    "5": {
        "startTime": 26.542,
        "endTime": 30.975,
        "transcript": "Angukarnamek-llu pinritaqamegteńga Taluarmek.",
        "translation": "And when they don't call me Angukarnaq, [it's] Taluar."
    },
    "6": {
        "startTime": 31.446,
        "endTime": 35.413,
        "transcript": "Taluarmek-llu pinritaqamegteńga Allirka'rmek.",
        "translation": "And when they don't call me Taluar, [it's] Allirkar."
    },
    "7": {
        "startTime": 35.926,
        "endTime": 38.46,
        "transcript": "Tau͡gaam ilait aperturngaitanka.",
        "translation": "But I won't say some of them."
    },
    "8": {
        "startTime": 38.474,
        "endTime": 40.252,
        "transcript": "Kass'atun-mi?",
        "translation": "What about in English?"
    },
    "9": {
        "startTime": 40.263,
        "endTime": 45.93,
        "transcript": "Kass'atun atengqertua Anissum Andrew Jacob.",
        "translation": "In English, I have the name Anissum Andrew Jacob."
    },
    "10": {
        "startTime": 46.386,
        "endTime": 48.953,
        "transcript": "Kitak' Anissum-aaq spell-aqerru.",
        "translation": "Please spell Anissum."
    },
    "11": {
        "startTime": 48.96,
        "endTime": 52.604,
        "transcript": "A-N-I-S-S-U-M.",
        "translation": "A-N-I-S-S-U-M."
    },
    "12": {
        "startTime": 52.833,
        "endTime": 56.877,
        "transcript": "Kalikaryugtuten-qaa? Ikani kalikanek. Cabinet-aangqertua ika-i.",
        "translation": "Do you want paper? Paper's across there. I have a cabinet across there."
    },
    "13": {
        "startTime": 56.878,
        "endTime": 59.778,
        "transcript": "Canrituq. Kiik' uuggun piyugngaaput.",
        "translation": "It's okay. We can do it with this."
    },
    "14": {
        "startTime": 59.797,
        "endTime": 61.975,
        "transcript": "Qavcinek allrakurluten maa-i?",
        "translation": "How old are you now?"
    },
    "15": {
        "startTime": 61.987,
        "endTime": 64.532,
        "transcript": "Maa-i 77.",
        "translation": "Now, 77."
    },
    "16": {
        "startTime": 64.543,
        "endTime": 67.198,
        "transcript": "Nani yuurtellrusit?",
        "translation": "Where were you born?"
    },
    "17": {
        "startTime": 67.207,
        "endTime": 70.663,
        "transcript": "Iqugmi, Russian Mission, Yukon.",
        "translation": "In Iquk, Russian Mission, Yukon [River]."
    },
    "18": {
        "startTime": 70.791,
        "endTime": 76.524,
        "transcript": "Qangvaq, qaill' piluten maavet upallrusit.",
        "translation": "When and why did you move here?"
    },
    "19": {
        "startTime": 82.525,
        "endTime": 90.236,
        "transcript": "Pau͡gavet Akulmun upallruukut up'nerkami, uksumi pau͡gavet Akulmun qamani.",
        "translation": "We moved inland to Akula in the spring, in the winter inland to Akula upriver."
    },
    "20": {
        "startTime": 92.472,
        "endTime": 101.172,
        "transcript": "Tua-i-llu my dad brother-aangqellruuq, oldest brother.",
        "translation": "Then my dad had a brother, [the] oldest brother."
    },
    "21": {
        "startTime": 102.406,
        "endTime": 109.739,
        "transcript": "Pingayunek yungqerrluni waten oldest brother tan'gaurluugnek malrugnek una-ll' nasaurluq.",
        "translation": "The oldest brother had three children like this, two boys and this girl."
    },
    "22": {
        "startTime": 109.747,
        "endTime": 114.202,
        "transcript": "Tua-i catairucami makumiumek uingluni tauna.",
        "translation": "When he was gone, that one married a man from here."
    },
    "23": {
        "startTime": 114.548,
        "endTime": 125.47,
        "transcript": "Tua-i pau͡gavet Akulmun taillemteńi ak'a up'nerkiyallemteńi tauna tan'gaurluum aipaa nutliniuq ellminek.",
        "translation": "When we came inland to Akula a long time ago for spring camp, that other boy shot himself."
    },
    "24": {
        "startTime": 125.484,
        "endTime": 132.461,
        "transcript": "Nutlagluni 12 gauge-aagnun. Man'a tua-i au͡g'arluku amiirluku waten [?]llermini.",
        "translation": "The 12 gauge misfired on him. It took this off, taking off the skin, when he [?] like this."
    },
    "25": {
        "startTime": 134.243,
        "endTime": 142.377,
        "transcript": "Tua-i tauna maliggluku. Utertellemteńi nall'arrluku.",
        "translation": "We went with him. When we were going home, we came across him."
    },
    "26": {
        "startTime": 143.215,
        "endTime": 148.971,
        "transcript": "Kuicarakun uterrluta qakmavet ayakatarluta.",
        "translation": "We returned through Kuicaraq to go up north."
    },
    "27": {
        "startTime": 150.002,
        "endTime": 161.965,
        "transcript": "Tua-i-ll' taum atamta tangrramiu tauna taum-llu tan'gaurluum taum maligtesqelluni, ayautesqelluni.",
        "translation": "Then when our father saw him, that boy asked to be brought along, to be brought somewhere."
    },
    "28": {
        "startTime": 161.967,
        "endTime": 167.511,
        "transcript": "Akiaq-gguq, Akiarmi-gguq hostpital-aartangqerrluni.",
        "translation": "He said that Akiak, there's a hospital in Akiak."
    },
    "29": {
        "startTime": 168.294,
        "endTime": 170.183,
        "transcript": "Tuavet ayaulluku.",
        "translation": "We brought him there."
    },
    "30": {
        "startTime": 170.193,
        "endTime": 176.116,
        "transcript": "Tua-i tuakenirnek maantukut, qamani-w' Ayimqeryarami, Kalskag. Nallunritan?",
        "translation": "We've been here since then, at least upriver in Ayimqeryaraq, Kalskag. You know it?"
    },
    "31": {
        "startTime": 176.555,
        "endTime": 177.91,
        "transcript": "Tuani.",
        "translation": "There."
    },
    "32": {
        "startTime": 178.064,
        "endTime": 185.864,
        "transcript": "Cami tau͡gaam piciitua. Maybe 1920-something, '28 or '29.",
        "translation": "But I'm not sure when. Maybe 1920-something, '28 or '29."
    },
    "33": {
        "startTime": 185.872,
        "endTime": 188.85,
        "transcript": "Tamatum au͡gatiini tuavet ellillruukut.",
        "translation": "We ended up there around then."
    },
    "34": {
        "startTime": 189.584,
        "endTime": 190.562,
        "transcript": "Up'nerkami.",
        "translation": "In the spring."
    },
    "35": {
        "startTime": 190.573,
        "endTime": 196.673,
        "transcript": "Qavcinek irniangqercit, tutgararluten, iluperarluten-llu iluperangqerquvet?",
        "translation": "How many children, grandchildren, and great-grandchildren if you have any do you have?"
    },
    "36": {
        "startTime": 198.94,
        "endTime": 201.495,
        "transcript": "Wiinga nakmiin piitua.",
        "translation": "I don't have any of my own."
    },
    "37": {
        "startTime": 201.503,
        "endTime": 209.481,
        "transcript": "Tau͡gaam ukut sister-aama irniarita irniari iluperaqanka.",
        "translation": "But my sister's children's children are my great-grandnephews and great-grandnieces."
    },
    "38": {
        "startTime": 209.731,
        "endTime": 217.875,
        "transcript": "Panika yaa-i Maggie adopted kid-angqertuq malrugnek, pingayunek, malrugnek tan'gaurluugnek.",
        "translation": "My daughter Maggie over there has two, [I mean] three adopted kids, two boys."
    },
    "39": {
        "startTime": 221.272,
        "endTime": 224.249,
        "transcript": "Iluperaanka qavciugat-wa tayima.",
        "translation": "I'm not sure how many great-grandchildren I have."
    },
    "40": {
        "startTime": 224.26,
        "endTime": 226.616,
        "transcript": "Tutgaraanka-ll' amllerrluteng.",
        "translation": "And I have many grandchildren."
    },
    "41": {
        "startTime": 226.869,
        "endTime": 232.824,
        "transcript": "Ika-i-ll' ikegkut tutgaraanka akmani nakmiin, yaa-i tang Barbara.",
        "translation": "And across there are my own grandchildren, over there is Barbara."
    },
    "42": {
        "startTime": 233.789,
        "endTime": 236.0,
        "transcript": "Barbara kina-llu?",
        "translation": "Barbara and who?"
    },
    "43": {
        "startTime": 236.662,
        "endTime": 252.912,
        "transcript": "Barbara, Mary, Alexandra, Matthew.",
        "translation": "Barbara, Mary, Alexandra, Matthew."
    },
    "44": {
        "startTime": 253.51,
        "endTime": 259.24,
        "transcript": "Atauciq-am anngaat, pika-i tang pikna anngaat, kit'ellruuq allragni.",
        "translation": "One of the older brothers, look at their older brother up there, drowned last year."
    },
    "45": {
        "startTime": 259.25,
        "endTime": 262.51,
        "transcript": "Yaa, allragni, allragni [?].",
        "translation": "Yes, last year, last year [?]."
    },
    "46": {
        "startTime": 263.215,
        "endTime": 274.775,
        "transcript": "Qaillun piluten star-amek umyuavnun qaill' tamana tut'ellrua piliyugluten?",
        "translation": "How did you get the idea to make a star?"
    },
    "47": {
        "startTime": 275.66,
        "endTime": 278.1,
        "transcript": "Piitellruut maani.",
        "translation": "They didn't have one here."
    },
    "48": {
        "startTime": 278.635,
        "endTime": 283.725,
        "transcript": "Qakmani Iqugmi S'laavilallratun pilillruyaaqanka.",
        "translation": "I made them one like how they celebrate Russian Christmas in Russian Mission to the north."
    },
    "49": {
        "startTime": 284.015,
        "endTime": 291.525,
        "transcript": "Agyaq, flag, una-w' cali waten akagtangqerrluni waten taktaluni.",
        "translation": "The star, a flag, and this has a ball that is this long."
    },
    "50": {
        "startTime": 291.535,
        "endTime": 295.195,
        "transcript": "Picirnirqeqapiggluni uivaarturcetaqluku tauna.",
        "translation": "It was very pleasant to spin that."
    },
    "51": {
        "startTime": 295.21,
        "endTime": 305.25,
        "transcript": "Tauna agyamek camek kenurrarmek pilallruat. Qakmani Iqugmi qaltayagmek piaqluku.",
        "translation": "They would call that the star, or what, the light. Up north in Russian mission, they call it a qaltayak."
    },
    "52": {
        "startTime": 305.935,
        "endTime": 310.745,
        "transcript": "Muragmek epungqerrluni, waten-ll' ayuqluni uivtanqeggluni.",
        "translation": "It has a wooden handle, and it round like this."
    },
    "53": {
        "startTime": 311.435,
        "endTime": 315.005,
        "transcript": "Maani pilillruanka plastic-aamek.",
        "translation": "I made one for them here out of plastic."
    },
    "54": {
        "startTime": 315.825,
        "endTime": 317.915,
        "transcript": "Qulii pikna keliscirluku.",
        "translation": "I put a cross above it up there."
    },
    "55": {
        "startTime": 317.925,
        "endTime": 323.355,
        "transcript": "Maa-i tanglartuten kelistarluni flag-am qulii, qaa?",
        "translation": "Now, you see a cross above a flag, right?"
    },
    "56": {
        "startTime": 323.365,
        "endTime": 325.435,
        "transcript": "Yaa, tuaten pilirluku.",
        "translation": "Yes, I made one for it like that."
    },
    "57": {
        "startTime": 325.445,
        "endTime": 332.915,
        "transcript": "Qaill'-mi tauna star-aq au͡gna teggliq wani star-aliarpenek cali qanrutqernga.",
        "translation": "Please tell me about that metal star, how you made that star."
    },
    "58": {
        "startTime": 332.925,
        "endTime": 333.555,
        "transcript": "Kina?",
        "translation": "Who?"
    },
    "59": {
        "startTime": 333.565,
        "endTime": 336.785,
        "transcript": "Teggliq au͡gna star-alian, cavik.",
        "translation": "The metal star you made, metal."
    },
    "60": {
        "startTime": 338.18,
        "endTime": 344.3,
        "transcript": "Nineteen-fifty-two-aami taumek piliarpenek qanemcitqernga qaillun piliaqellerpenek.",
        "translation": "Please tell me about how you made what you made in 1952."
    },
    "61": {
        "startTime": 344.335,
        "endTime": 346.745,
        "transcript": "Piliaqellruaqa ak'anun.",
        "translation": "I worked on it for a long time."
    },
    "62": {
        "startTime": 347.895,
        "endTime": 353.855,
        "transcript": "Maybe two, three, two, three weeks piliaqlua, maybe two weeks.",
        "translation": "Maybe two, three, two, three weeks I worked on it, maybe two weeks."
    },
    "63": {
        "startTime": 353.87,
        "endTime": 360.92,
        "transcript": "Elitnaurvigmi janitor-aarulua yaani. Atakumi caliaqaqluku taq'aqama.",
        "translation": "I was a janitor at the school over there. I'd work on it in the evening when I was done."
    },
    "64": {
        "startTime": 361.77,
        "endTime": 364.71,
        "transcript": "Ernerpak piksaunaku, atakumi tau͡gaam.",
        "translation": "I wouldn't do it all day, except in the evening."
    },
    "65": {
        "startTime": 364.875,
        "endTime": 374.725,
        "transcript": "Calissuutaunii cat-wa pivailgata. Kenurraunata-ll' electric-aanek, kenurrapianek tau͡gaam.",
        "translation": "And I didn't have tools, well, before [Western] things came. And we didn't have electric lights, only traditional lamps."
    },
    "66": {
        "startTime": 377.67,
        "endTime": 380.81,
        "transcript": "Drill-arturluku waten piurlua.",
        "translation": "I'd keep drilling it like this."
    },
    "67": {
        "startTime": 382.425,
        "endTime": 387.605,
        "transcript": "Tangellruan-qaa au͡gani? Naparyarluni pinek wani.",
        "translation": "Did you see it over there? It has poles of something."
    },
    "68": {
        "startTime": 387.62,
        "endTime": 399.28,
        "transcript": "Tamakut-llu naparyat hospital-aaq kitugtellermeggni egqellrit kiani ceńami wiinga teguluki aturluki au͡ga-i naparyanun.",
        "translation": "And those poles, what they'd thrown away when fixing the hospital, I took from the shore upriver and used them for the poles."
    },
    "69": {
        "startTime": 399.285,
        "endTime": 404.185,
        "transcript": "Copper-aaruut, you know. Assirluteng.",
        "translation": "They're copper, you know. They're good."
    },
    "70": {
        "startTime": 405.14,
        "endTime": 412.38,
        "transcript": "Agyaq-llu, agyaq-llu five gallon can.",
        "translation": "And the star, and the star [was made with a] five gallon can."
    },
    "71": {
        "startTime": 412.385,
        "endTime": 415.725,
        "transcript": "Five gallon can-anek pilallruut imumi.",
        "translation": "They had five gallon cans long ago."
    },
    "72": {
        "startTime": 415.74,
        "endTime": 418.35,
        "transcript": "Nalluyugtarquten taukunek.",
        "translation": "You probably don't know of those."
    },
    "73": {
        "startTime": 418.63,
        "endTime": 427.18,
        "transcript": "Five gallon can gas, Blazo, kerosene, tamakunek.",
        "translation": "Five gallon can [of] gas, Blazo, kerosene, those things."
    },
    "74": {
        "startTime": 427.19,
        "endTime": 429.34,
        "transcript": "Five gallon-aanek assigtarluteng.",
        "translation": "They had five gallon containers."
    },
    "75": {
        "startTime": 429.72,
        "endTime": 438.94,
        "transcript": "Tamakucimek pilua imailngurmek qallenrilan unailan-ll' nuussicuarluku elirqelluku.",
        "translation": "I took an empty one of those because it wasn't rusty and was soft, and cut it into pieces with scissors."
    },
    "76": {
        "startTime": 439.605,
        "endTime": 442.425,
        "transcript": "Elirqerraarluku caviyaarmek teggucirluki.",
        "translation": "After cutting them, I secured them with a wire."
    },
    "77": {
        "startTime": 444.2,
        "endTime": 445.58,
        "transcript": "Mikcuarmek.",
        "translation": "A small one."
    },
    "78": {
        "startTime": 445.895,
        "endTime": 450.885,
        "transcript": "Solder-aaqsaunaki, qillertaqluki tau͡gaam.",
        "translation": "I wouldn't solder them, but tie them."
    },
    "79": {
        "startTime": 451.215,
        "endTime": 452.595,
        "transcript": "Cavignek?",
        "translation": "Metal?"
    },
    "80": {
        "startTime": 452.61,
        "endTime": 454.06,
        "transcript": "Ii-i.",
        "translation": "Yes."
    },
    "81": {
        "startTime": 454.07,
        "endTime": 456.44,
        "transcript": "Caviyaarmek qillertaqluki.",
        "translation": "I'd tie them with wires."
    },
    "82": {
        "startTime": 457.09,
        "endTime": 466.7,
        "transcript": "Ak'anun piliaqellruaqa. Two weeks piyugnarqaqa iciw' atakumi tau͡gaam piliaqelaamku taqsuqsuitellemni-w' tua-i.",
        "translation": "I worked on it for a long time. I think I did it for two weeks, you know, because I'd only work on it in the evening when I used to not get tired."
    },
    "83": {
        "startTime": 467.62,
        "endTime": 473.0,
        "transcript": "Maani, un'gani, un'gani wiinga unegkumiunguunga.",
        "translation": "Here, downriver, I am from downriver."
    },
    "84": {
        "startTime": 473.005,
        "endTime": 483.615,
        "transcript": "Un'gani maa-i waten pitangqertuq: kiingan ak'allarpallurnek aturtengqerraqluteng S'laaviraqameng.",
        "translation": "Downriver now, there are these: they only have old singers during Russian Christmas."
    },
    "85": {
        "startTime": 483.625,
        "endTime": 487.905,
        "transcript": "Maani, maani tau͡gken waten ayagyuat amllenrunganateng.",
        "translation": "Here, however, there seems to be more youth like this."
    },
    "86": {
        "startTime": 487.92,
        "endTime": 488.45,
        "transcript": "Yaa.",
        "translation": "Yes."
    },
    "87": {
        "startTime": 488.46,
        "endTime": 497.47,
        "transcript": "Qaillun tamana elpeci-qaa ciuliarni cingluki elitnauci? Tamatumek kitak' qanrutqernga cali.",
        "translation": "Do you elders somehow encourage and teach them? Please tell me about that too."
    },
    "88": {
        "startTime": 498.33,
        "endTime": 506.71,
        "transcript": "Atam, man'a maa-i watua nutarat aturtet makut",
        "translation": "Look, these new singers now"
    },
    "89": {
        "startTime": 507.155,
        "endTime": 519.925,
        "transcript": "Pisciigatait makut ak'allaat maligtaqusciigatait kalikatgun yuarutetgun aturyaurcameng, Kass'at yuarutaitgun.",
        "translation": "They can't sing or follow these old [songs] because they've started using songbooks, Western songs."
    },
    "90": {
        "startTime": 520.315,
        "endTime": 525.875,
        "transcript": "Ak'a tau͡gken tamaani tamakut tangssuitellruut kalikanek aturcuutnek.",
        "translation": "Long ago, however, they never saw those songbooks."
    },
    "91": {
        "startTime": 526.74,
        "endTime": 536.12,
        "transcript": "Tua-i tau͡gaam ellaita aturluteng, ellaita pimegteggun aturluteng.",
        "translation": "Instead, they sang, they sang with their own [memory]."
    },
    "92": {
        "startTime": 536.435,
        "endTime": 541.865,
        "transcript": "Watua tau͡gken nallunritaten, ak'allaat un'gani ava-i qanrutkaten.",
        "translation": "Now, however, as you know, you just spoke about the old ones downriver."
    },
    "93": {
        "startTime": 541.875,
        "endTime": 548.075,
        "transcript": "Atulartat au͡gaggun elitellermegteggun, kiituani maavet ellilliniut waniw.",
        "translation": "They sing with what they learned back then, and eventually, they've reached this time."
    },
    "94": {
        "startTime": 549.66,
        "endTime": 560.43,
        "transcript": "Tua-i-ll' watua makut tamakutgun kalikatgun atulaameng ak'allarkun maligtesciigatut nutaraungami tamana.",
        "translation": "Then now, since they use those books, they cannot go along with the old way because that's new."
    },
    "95": {
        "startTime": 561.11,
        "endTime": 567.03,
        "transcript": "Kass'atun-ll' aturyaurrluteng. Ak'a Yugtun atutullruut.",
        "translation": "And they've started singing in English. They sang in Yup'ik long ago."
    },
    "96": {
        "startTime": 567.165,
        "endTime": 573.665,
        "transcript": "Elpet nallevni wani imumi waten S'laavircuutnek aturpagaqata",
        "translation": "During your time back then, when they sang Russian Christmas songs like this"
    },
    "97": {
        "startTime": 574.36,
        "endTime": 581.45,
        "transcript": "Qaillun pitalriamek elpeci elitellruceci kalikaunaci tayima atutullerpeceńi?",
        "translation": "How much did you learn when you didn't use books?"
    },
    "98": {
        "startTime": 581.46,
        "endTime": 591.98,
        "transcript": "Kalikaunata atutullruukut imumi qamani tan'gaurlullraullemni elitnaurlua Ayimqeryarami.",
        "translation": "We used to sing without books upriver back when I was a little boy going to school in Kalskag."
    },
    "99": {
        "startTime": 591.985,
        "endTime": 599.715,
        "transcript": "Qama-i atauciq ilakelalqa Ayimqeryarami qama-i atauciq ellirtuq.",
        "translation": "Upriver, one of my former peers, there's one left in Kalskag upriver."
    },
    "100": {
        "startTime": 599.885,
        "endTime": 602.705,
        "transcript": "Ak'allauluni-llu.",
        "translation": "And he's old."
    },
    "101": {
        "startTime": 603.37,
        "endTime": 606.89,
        "transcript": "Ilait tau͡gken... tamarmeng tayim' catairulluteng.",
        "translation": "Some, however.... all of them have passed away."
    },
    "102": {
        "startTime": 608.405,
        "endTime": 616.235,
        "transcript": "Ayimqeryaramun tekiskuvet apqauquvet niiciiqan [?Zakhar] Levi.",
        "translation": "When you go to Kalskag and ask around, you'll hear about [?Zakhar] Levi."
    },
    "103": {
        "startTime": 616.785,
        "endTime": 619.675,
        "transcript": "Angutngurteqapiartuq tauna.",
        "translation": "He's become a very old man."
    },
    "104": {
        "startTime": 620.295,
        "endTime": 622.565,
        "transcript": "Aturteńgullruuq.",
        "translation": "He was a singer."
    },
    "105": {
        "startTime": 623.065,
        "endTime": 627.605,
        "transcript": "Aturteńguluni agayulriani-llu ciuqliugaqluni.",
        "translation": "He was a singer, and was the lead during church."
    },
    "106": {
        "startTime": 628.44,
        "endTime": 635.99,
        "transcript": "Tua-i-ll' maa-i watua tuaten pinrirtuq. Allat tau͡gaam pingluteng, iciw' cat makut tan'gaurluut nutarat.",
        "translation": "Then now, he's stopped doing that. Others have instead started, you know, these new boys."
    },
    "107": {
        "startTime": 636.28,
        "endTime": 642.63,
        "transcript": "Naaqiyuicaaquq tau͡gaam atutuluni. Naaqillerkani nalluluku.",
        "translation": "He doesn't read, but he sings. He doesn't know how to read."
    },
    "108": {
        "startTime": 642.64,
        "endTime": 656.06,
        "transcript": "Tamaani-qaa elicugallerpeceńi cumigtenrungatellruuci maa-i ayagyuani elitnaullratni yuarutnek?",
        "translation": "Back when you were learning, did you seem more focused than the youth today who are learning songs?"
    },
    "109": {
        "startTime": 657.945,
        "endTime": 664.045,
        "transcript": "Aren, qanerciigatua qaillun. Tamana nalluaqa.",
        "translation": "Oh my, I can't say anything. I don't know that."
    },
    "110": {
        "startTime": 664.25,
        "endTime": 668.12,
        "transcript": "Tua-i elitnaullruukut wangkuta.",
        "translation": "We [practiced to] learn."
    },
    "111": {
        "startTime": 668.81,
        "endTime": 672.17,
        "transcript": "Elitnaurluta aturyaranek.",
        "translation": "We [practiced to] learn how to sing."
    },
    "112": {
        "startTime": 672.175,
        "endTime": 677.165,
        "transcript": "Kalikanek-llu naaqisciiganata, atulria tau͡gaam maliggluku.",
        "translation": "And we couldn't read books, but followed the one who was singing."
    },
    "113": {
        "startTime": 678.925,
        "endTime": 682.745,
        "transcript": "Atulria yuarutmek atulria maliggluku.",
        "translation": "We followed the one singing the song."
    },
    "114": {
        "startTime": 682.76,
        "endTime": 684.97,
        "transcript": "Tua-i tau͡gaam tuaten.",
        "translation": "Only like that."
    },
    "115": {
        "startTime": 684.98,
        "endTime": 691.8,
        "transcript": "Watua tau͡gken maa-i igarluteng. Igarluteng, igarluteng.",
        "translation": "Now, however, they write. They write, they write."
    },
    "116": {
        "startTime": 691.885,
        "endTime": 695.615,
        "transcript": "Tamaaggun kalikatgun atutuluteng.",
        "translation": "They sing with those books."
    },
    "117": {
        "startTime": 695.965,
        "endTime": 701.545,
        "transcript": "Tau͡gaam imumi imkutgun kalikatgun piyaurcameng yuarutetgun",
        "translation": "But long ago when they started using those books with songs"
    },
    "118": {
        "startTime": 701.78,
        "endTime": 706.49,
        "transcript": "Iciw' yuarutetangqellria qaill' elliurturalria. Nallunritaten?",
        "translation": "You know there's a song that goes somehow like this. Do you know them?"
    },
    "119": {
        "startTime": 706.5,
        "endTime": 709.21,
        "transcript": "Tamakutgun aturyaurtut maa-i.",
        "translation": "They've started singing with those now."
    },
    "120": {
        "startTime": 710.85,
        "endTime": 715.31,
        "transcript": "Atauciq wani nangneq apyutkaqa, apyutkaqa wani nangneq.",
        "translation": "I ask one last thing, my last question."
    },
    "121": {
        "startTime": 717.495,
        "endTime": 720.095,
        "transcript": "Cauga elpeni S'laaviq?",
        "translation": "What's Russian Christmas to you?"
    },
    "122": {
        "startTime": 720.21,
        "endTime": 723.73,
        "transcript": "Wangni-qaa? Nallukeka-wa wii S'laaviq.",
        "translation": "To me? I don't know about Russian Christmas."
    },
    "123": {
        "startTime": 723.735,
        "endTime": 729.345,
        "transcript": "Cauga wani elpeni S'laaviq? Camek elpeni meaning-aangqerta S'laavi[?]",
        "translation": "What's Russian Christmas to you? What does Russian Christmas to you?"
    },
    "124": {
        "startTime": 732.735,
        "endTime": 742.935,
        "transcript": "Tan'gaurlullraulua-w' tamaani ayallruama tua-i tau͡gaam imumi ak'a S'laavilallruukut Kuigpagmi qakmani Iqugmi.",
        "translation": "Because I went away as a little boy back then, but we used to have Russian Christmas long ago on the Yukon River, up north in Russian Mission."
    },
    "125": {
        "startTime": 743.64,
        "endTime": 752.45,
        "transcript": "Tan'gaurlull'errlainauluta wangkuta. Tan'gaurlull'errlainauluta S'laaviraqluta.",
        "translation": "We woud all be boys. We would have Russian Christmas with all boys."
    },
    "126": {
        "startTime": 753.42,
        "endTime": 761.59,
        "transcript": "Angelrianek yugnek, iciw' angelrianek watua murilkesterluta.",
        "translation": "Grown people, you know, we had grown ups watching us."
    },
    "127": {
        "startTime": 762.01,
        "endTime": 765.15,
        "transcript": "Qavcinek malrugnek wall' ataucimek.",
        "translation": "How many, two or one."
    },
    "128": {
        "startTime": 768.255,
        "endTime": 771.375,
        "transcript": "S'laaviraqluta tua-i.",
        "translation": "We'd have Russian Christmas."
    },
    "129": {
        "startTime": 775.5,
        "endTime": 780.2,
        "transcript": "Alussistuaq ayuqaa, Christmas-aaq.",
        "translation": "It's the same as Alussistuaq, Christmas."
    },
    "130": {
        "startTime": 780.695,
        "endTime": 783.515,
        "transcript": "Christmas-aatun tua-i S'laavirluta.",
        "translation": "We'd have Russian Christmas like Christmas."
    },
    "131": {
        "startTime": 784.01,
        "endTime": 787.54,
        "transcript": "Tau͡gaam Merry Christmas-aayuunata.",
        "translation": "But we wouldn't say \"Merry Christmas.\""
    },
    "132": {
        "startTime": 788.19,
        "endTime": 791.61,
        "transcript": "Taq'aqamta-llu waten piyuunata: \"Merry Christmas.\"",
        "translation": "And we didn't say this when we were done: \"Merry Christmas.\""
    },
    "133": {
        "startTime": 791.615,
        "endTime": 794.085,
        "transcript": "Piyuunata nalluluku.",
        "translation": "We wouldn't because we didn't know it."
    },
    "134": {
        "startTime": 794.095,
        "endTime": 801.725,
        "transcript": "[?Prázdniku, prázdniku] tua-i tau͡gaam.",
        "translation": "[?Prázdniku, prázdniku] only that."
    },
    "135": {
        "startTime": 802.245,
        "endTime": 806.045,
        "transcript": "Merry Christma-amek-llu qanelriamek niicuunata.",
        "translation": "And we never heard anyone say, \"Merry Christmas.\""
    },
    "136": {
        "startTime": 807.64,
        "endTime": 816.14,
        "transcript": "Elitnaurvigmi tau͡gaam Alussistuarqameng Merry Christmas-aaraqluteng.",
        "translation": "Only when they had Christmas at school did they say, \"Merry Christmas.\""
    },
    "137": {
        "startTime": 816.755,
        "endTime": 824.355,
        "transcript": "Yuut imkut Kass'alugpianun Kass'alugpiarrlainartun-llu agayutuluteng maaten ellangua.",
        "translation": "In my earliest memories, I realized that people would go to church at the Russian Orthodox church held only in Russian."
    },
    "138": {
        "startTime": 824.87,
        "endTime": 831.21,
        "transcript": "Maa-i English-aatun piyuunateng, Yugtun-llu piyuunateng, Kass'alugpiarrlainartun tau͡gaam.",
        "translation": "Now, they wouldn't do it in English, and wouldn't do it in Yup'ik, but only in Russian."
    },
    "139": {
        "startTime": 832.105,
        "endTime": 835.785,
        "transcript": "Kass'alugpiarrlainartun-llu naaqituluteng.",
        "translation": "And they would read only in Russian."
    },
    "140": {
        "startTime": 836.94,
        "endTime": 839.62,
        "transcript": "No English, just Russian.",
        "translation": "No English, just Russian."
    },
    "141": {
        "startTime": 840.805,
        "endTime": 842.785,
        "transcript": "Tua-i kiingita.",
        "translation": "Just those."
    },
    "142": {
        "startTime": 843.31,
        "endTime": 845.87,
        "transcript": "Allgiliyarluteng-llu.",
        "translation": "And they had a high priest."
    },
    "143": {
        "startTime": 847.295,
        "endTime": 853.215,
        "transcript": "Naaqisterluni Nicky [?]-mek agayulirtellermek.",
        "translation": "His reader was the former priest Nicky [?]."
    },
    "144": {
        "startTime": 854.04,
        "endTime": 862.2,
        "transcript": "Qanerturnaurtuq tauna allgiliyaq Kass'alugpiatun, taum tau͡gken Nicky [?]-m mumiggluku Yugtun.",
        "translation": "That high priest would speak in Russian, but Nicky [?] would translate it into Yup'ik."
    },
    "145": {
        "startTime": 865.075,
        "endTime": 868.385,
        "transcript": "Yugtun puqikapiarluni tauna Nicky [?]-q.",
        "translation": "That Nicky [?] was very fluent in Yup'ik."
    },
    "146": {
        "startTime": 869.225,
        "endTime": 871.815,
        "transcript": "Cauluni? Yupiuluni wall'u-q' cauluni?",
        "translation": "What was he? Was he Yup'ik or what?"
    },
    "147": {
        "startTime": 871.825,
        "endTime": 876.685,
        "transcript": "Yupiuluni amkumiunguluni.",
        "translation": "He was Yup'ik from over there."
    },
    "148": {
        "startTime": 879.83,
        "endTime": 884.75,
        "transcript": "Unalaska Tayarumiunek pilaryugnarqaat Yugtun.",
        "translation": "I think they refer to Unalaska as Tayarumiut it Yup'ik."
    },
    "149": {
        "startTime": 884.925,
        "endTime": 889.275,
        "transcript": "Agayulirteńgullrulliniluni. Tamaaken tailuni.",
        "translation": "He'd apparently been a priest. He came from there."
    },
    "150": {
        "startTime": 889.355,
        "endTime": 892.595,
        "transcript": "Agayulirteńgunriami naaqisteńguluni.",
        "translation": "When he was no longer a priest, he became a reader."
    },
    "151": {
        "startTime": 892.61,
        "endTime": 901.13,
        "transcript": "Allgiliyam-llu, allgiliyam-llu qanertekluku.",
        "translation": "And hewas the high priest's speaker."
    },
    "152": {
        "startTime": 904.495,
        "endTime": 912.845,
        "transcript": "Atam sometime ayakuvet Iqugmun qakmavet, Russian Mission, Yukon, Russian Mission",
        "translation": "Look, if sometime you go to Iquk in the north, Russian Mission, Yukon, Russian Mission"
    },
    "153": {
        "startTime": 913.885,
        "endTime": 919.125,
        "transcript": "Atam qakmani yuk atauciq Qakngacanrituq",
        "translation": "Look, up north, there's one person, Qakngacanrituq."
    },
    "154": {
        "startTime": 920.13,
        "endTime": 927.03,
        "transcript": "Wiinga-ll' ciulirneqluku. Maybe two years or three years ciulierneqaqa tauna Qakngacanrituq.",
        "translation": "And he's my senior. He's maybe two years or three years my senior, that Qakngacanrituq."
    },
    "155": {
        "startTime": 927.035,
        "endTime": 932.695,
        "transcript": "Nallunritaqa. Elitnaullgutelqaqa qakmani Iqugmi uitallemni ayagpailegma.",
        "translation": "I know him. I went to school with him when I lived up north in Russian Mission before I left."
    },
    "156": {
        "startTime": 932.71,
        "endTime": 938.39,
        "transcript": "Taum elluarrluku qanruciiqaaten, nallukemnek-llu tayima.",
        "translation": "He will tell you things right, and probably what I don't know."
    },
    "157": {
        "startTime": 938.975,
        "endTime": 940.335,
        "transcript": "Ii-i, quyana.",
        "translation": "Okay, thank you."
    },
    "158": {
        "startTime": 940.35,
        "endTime": 941.39,
        "transcript": "Yaa.",
        "translation": "You're welcome."
    },
    "159": {
        "startTime": 941.395,
        "endTime": 944.335,
        "transcript": "Qanruciiqaaten atam tuavet ayakuvet.",
        "translation": "Watch, he will tell you if you go there."
    },
    "160": {
        "startTime": 944.5,
        "endTime": 946.39,
        "transcript": "Atam sometime aya[kuvet]...",
        "translation": "Watch, if you go sometime..."
    }
};